export const UserRole = {
    USER: "USER",
    ADMIN: "ADMIN",
};
export const UserStatus = {
    INVITED: "INVITED",
    REGISTERED: "REGISTERED",
    EMAIL_PENDING: "EMAIL_PENDING",
    ACTIVE: "ACTIVE",
    DISABLED: "DISABLED",
};
export const FlightOfferStatus = {
    ACTIVE: "ACTIVE",
    FULL: "FULL",
    CANCELLED_BY_PILOT: "CANCELLED_BY_PILOT",
    CANCELLED_BY_ADMIN: "CANCELLED_BY_ADMIN",
    EXPIRED: "EXPIRED",
};
export const FlightOfferSource = {
    MANUAL: "MANUAL",
    VEREINSFLIEGER: "VEREINSFLIEGER",
};
export const BookingRequestStatus = {
    REQUESTED: "REQUESTED",
    WAITLISTED: "WAITLISTED",
    CONFIRMED: "CONFIRMED",
    REJECTED: "REJECTED",
    CANCELLED: "CANCELLED",
};
export const AppSettingKey = {
    OFFER_EXPIRY_OFFSET_MINUTES: "offerExpiryOffsetMinutes",
};
//# sourceMappingURL=enums.js.map